import React from "react";

function renderStars(count) {
  const stars = [];

  for (let i = 1; i <= count; i += 1) {
    stars.push(<span aria-hidden data-icon="&#x61;" key={i} />);
  }

  return stars;
}

const HotelRating = ({ rating, ratingText }) => {
  let text;

  if (ratingText) {
    let microDatas = {};
    if (rating) {
      microDatas = {
        itemProp: "starRating",
        itemScope: true,
        itemType: "https://schema.org/Rating",
      };
    }

    text = (
      <span className="invisible" {...microDatas}>
        {ratingText}
        {!!rating && <meta itemProp="ratingValue" content={rating} />}
      </span>
    );
  }

  return (
    <span key={rating || 0} className="rating">
      {text}
      {renderStars(rating)}
    </span>
  );
};

export default HotelRating;
